var _templateObject = _taggedTemplateLiteralLoose(['\n  animation-duration: 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeHolderShimmer;\n  animation-timing-function: linear;\n  background: #f6f7f8;\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n  background-size: 800px 104px;\n  position: relative;\n  margin: 5px;\n  height: ', ';\n  width: ', ';\n  border-radius: 5px;\n\n  @keyframes placeHolderShimmer{\n    0%{\n        background-position: -468px 0\n    }\n    100%{\n        background-position: 468px 0\n    }\n  }\n'], ['\n  animation-duration: 1.5s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeHolderShimmer;\n  animation-timing-function: linear;\n  background: #f6f7f8;\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n  background-size: 800px 104px;\n  position: relative;\n  margin: 5px;\n  height: ', ';\n  width: ', ';\n  border-radius: 5px;\n\n  @keyframes placeHolderShimmer{\n    0%{\n        background-position: -468px 0\n    }\n    100%{\n        background-position: 468px 0\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';
import PropTypes from 'prop-types';

var DataLoading = styled.div(_templateObject, function (props) {
  return props.h + 'px';
}, function (props) {
  return '' + (props.w ? props.w + 'px' : 'auto');
});

DataLoading.displayName = 'DataLoading';

DataLoading.propTypes = {
  h: function h(props, propName, componentName) {
    if (isNaN(props[propName]) || props[propName] <= 0) {
      return new Error('Invalid prop ' + propName + ' supplied to ' + componentName + '. value must be a number greater than 0');
    }
  },
  w: PropTypes.number
};

DataLoading.defaultProps = {
  h: 15
};

export default DataLoading;